module.exports = __webpack_public_path__ + "img/Categories_bg_02.43113491.jpg";